import React, { useState } from "react";
import MenuList from "../components/MenuList";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

const imageUrl = "banner3.webp";

const Menu = () => {
  const [filter, setFilter] = useState("all");

  const handleFilterChange = (event, newFilter) => {
    if (newFilter !== null) {
      setFilter(newFilter);
    }
  };

  return (
    <>
      <Container maxWidth="xl" sx={{ mt: 12 }}>
        <Box
          sx={{
            height: 400,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            color: "#fff",
            textAlign: "center",
            p: 3,
            marginTop: 2,
          }}
        />
      </Container>

      <Container maxWidth="xl" sx={{ my: 4 }}>
        <ToggleButtonGroup
          color="primary"
          value={filter}
          exclusive
          onChange={handleFilterChange}
          sx={{ mb: 2 }}
        >
          <ToggleButton value="all">All</ToggleButton>
          <ToggleButton value="Veg">Vegetarian</ToggleButton>
          <ToggleButton value="Non-Veg">Non-Vegetarian</ToggleButton>
        </ToggleButtonGroup>
        <MenuList filter={filter} />
      </Container>
    </>
  );
};

export default Menu;
